class QuestionCorrectionResult {
  /**
   * 试题纠错信息id
   */
  questionId: string
  /**
   * 纠错状态 1，未处理，2：已处理
   */
  status: number
}

export default QuestionCorrectionResult
